import { render } from "./DeclencheurCustomJS.vue?vue&type=template&id=072d603f&scoped=true"
import script from "./DeclencheurCustomJS.vue?vue&type=script&lang=ts"
export * from "./DeclencheurCustomJS.vue?vue&type=script&lang=ts"

import "./DeclencheurCustomJS.vue?vue&type=style&index=0&id=072d603f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-072d603f"

export default script